function initProductGallery() {
    var mainSwiper = new Swiper("#product-gallery-slider", {
      spaceBetween: 10,
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: "#product-gallery-slider .gallery-nav.swiper-button-next",
        prevEl: "#product-gallery-slider .gallery-nav.swiper-button-prev",
      },
      on: {
        slideChange: function() {
          updateActiveThumbnail(this.activeIndex);
        }
      }
    });

    window.mainSwiper = mainSwiper;
  }
  function goToSlide(index) {
    if (window.mainSwiper) {
      window.mainSwiper.slideTo(index);
    }
    updateActiveThumbnail(index);
  }
  function updateActiveThumbnail(index) {
    var thumbnails = document.querySelectorAll('#product-thumbnails .thumbnail-item');
    thumbnails.forEach(function(el, i) {
      el.classList.toggle('active', i === index);
    });
    // Scroll active thumbnail into view
    if (thumbnails[index]) {
      thumbnails[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    initProductGallery();
    updateVariant();
  });
  document.addEventListener('shopify:section:load', () => {
    initProductGallery();
    updateVariant();
  });

  const productVariants = window.productVariants || [];
  const productOptions = window.productOptions || [];

  function formatProductMoney(cents) {
    if (typeof window.formatMoney === 'function' && window.formatMoney !== formatProductMoney) {
      return window.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function selectVariantOption(optionName, optionValue, el) {
    const wrappers = document.querySelectorAll('.variant-select-wrapper');
    const clickedWrapper = el.closest('.variant-select-wrapper');
    const wrapperIndex = Array.from(wrappers).indexOf(clickedWrapper);

    // Apply the active state to the clicked item first
    const container = el.closest('.variant-options');
    container.querySelectorAll('.option-button, .swatch-item').forEach(item => item.classList.remove('active'));
    el.classList.add('active');

    const labelSpan = clickedWrapper.querySelector('.selected-value');
    if (labelSpan) labelSpan.innerText = optionValue;

    // Get current selections across all wrappers
    let currentSelection = Array.from(wrappers).map(w => {
      const activeEl = w.querySelector('.active');
      return activeEl ? activeEl.getAttribute('data-value') : null;
    });

    // Check if the current combination is valid
    const exactMatch = productVariants.find(v => {
      return v.options.every((opt, idx) => opt === currentSelection[idx]);
    });

    // If the combination is invalid, find the first valid variant matching the newly clicked option value
    if (!exactMatch && wrapperIndex !== -1) {
      const fallbackMatch = productVariants.find(v => v.options[wrapperIndex] === optionValue);
      if (fallbackMatch) {
        wrappers.forEach((w, idx) => {
          const valueToSelect = fallbackMatch.options[idx];
          w.querySelectorAll('.option-button, .swatch-item').forEach(item => {
            const itemValue = item.getAttribute('data-value');
            item.classList.toggle('active', itemValue === valueToSelect);
          });
          const lSpan = w.querySelector('.selected-value');
          if (lSpan) lSpan.innerText = valueToSelect;
        });
      }
    }

    updateOptionsAvailability();
    updateVariant();
  }

  function updateOptionsAvailability() {
    const wrappers = document.querySelectorAll('.variant-select-wrapper');
    if (!wrappers.length) return;

    wrappers.forEach((wrapper, wrapperIndex) => {
      const optionsButtons = wrapper.querySelectorAll('.option-button, .swatch-item');

      optionsButtons.forEach(btn => {
        const btnValue = btn.getAttribute('data-value');

        // Check if this specific value is available given other selections
        const isAvailable = productVariants.some(variant => {
          // A variant is a potential match if it has this button's value for this option
          if (variant.options[wrapperIndex] !== btnValue) return false;

          // AND it matches the selected values of all OTHER options
          return variant.options.every((optValue, optIndex) => {
            if (optIndex === wrapperIndex) return true; // skip current option

            const otherWrapper = wrappers[optIndex];
            const otherSelected = otherWrapper.querySelector('.active');
            if (!otherSelected) return true;

            return optValue === otherSelected.getAttribute('data-value');
          });
        });

        if (isAvailable) {
          btn.classList.remove('unavailable');
        } else {
          btn.classList.add('unavailable');
        }
      });
    });
  }

  // Run on initial load
  document.addEventListener('DOMContentLoaded', updateOptionsAvailability);
  document.addEventListener('shopify:section:load', updateOptionsAvailability);

  function updateProductQty(delta) {
    const qtyInput = document.getElementById('product-quantity');
    if (!qtyInput) return;
    let val = parseInt(qtyInput.value) || 1;
    val = val + delta;
    if (val < 1) val = 1;
    qtyInput.value = val;
  }

  function updateVariant() {
    const selectedOptions = Array.from(document.querySelectorAll('.variant-options .active')).map(el => {
      return el.classList.contains('swatch-item') ? el.getAttribute('title') : el.textContent.trim();
    });

    let variant;
    if (selectedOptions.length === 0 && productVariants.length > 0) {
      variant = productVariants[0];
    } else {
      variant = productVariants.find(v => {
        return v.options.every((opt, index) => opt === selectedOptions[index]);
      });
    }

    if (variant) {
      document.getElementById('product-variant-id').value = variant.id;
      document.getElementById('price-display').innerText = formatProductMoney(variant.price);

      const comparePriceEl = document.getElementById('compare-price-display');
      const discountBadge = document.getElementById('discount-badge');

      if (variant.compare_at_price > variant.price) {
        if (comparePriceEl) {
          comparePriceEl.innerText = formatProductMoney(variant.compare_at_price);
          comparePriceEl.style.display = 'inline';
        }
        if (discountBadge) {
          const discount = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          discountBadge.innerText = 'SAVE ' + discount + '%';
          discountBadge.style.display = 'inline';
        }
      } else {
        if (comparePriceEl) comparePriceEl.style.display = 'none';
        if (discountBadge) discountBadge.style.display = 'none';
      }

      // Update slider to variant image index
      if (variant.featured_media && window.mainSwiper) {
        const mediaId = variant.featured_media.id;
        const slides = Array.from(document.querySelectorAll('#product-gallery-slider .swiper-slide'));
        const index = slides.findIndex(slide => slide.dataset.mediaId == mediaId);
        if (index !== -1) {
          window.mainSwiper.slideTo(index);
        }
      }

      const atcBtn = document.querySelector('.btn-atc');
      const statusStock = document.querySelector('.status-stock');
      const checkoutButtons = document.querySelector('.dynamic-checkout-buttons');

      if (variant.available) {
        atcBtn.innerText = 'ADD TO CART';
        atcBtn.disabled = false;
        atcBtn.style.opacity = '1';
        if (checkoutButtons) checkoutButtons.style.display = 'block';
        if (statusStock) {
          statusStock.innerText = 'In Stock';
          statusStock.classList.remove('out-of-stock');
        }

        // Remove return_to if it exists
        const returnTo = document.querySelector('input[name="return_to"]');
        if (returnTo) returnTo.remove();
      } else {
        atcBtn.innerText = 'PRE ORDER';
        atcBtn.disabled = false;
        atcBtn.style.opacity = '1';
        if (checkoutButtons) checkoutButtons.style.display = 'none';
        if (statusStock) {
          statusStock.innerText = 'Out of Stock';
          statusStock.classList.add('out-of-stock');
        }

        // Add return_to checkout for pre-order behavior
        let returnTo = document.querySelector('input[name="return_to"]');
        if (!returnTo) {
          returnTo = document.createElement('input');
          returnTo.type = 'hidden';
          returnTo.name = 'return_to';
          returnTo.value = '/checkout';
          document.getElementById('product-form').appendChild(returnTo);
        }
      }
    }
  }

  function shareProduct() {
    if (navigator.share) {
      navigator.share({
        title: document.title,
        url: window.location.href
      });
    } else {
      alert('Share URL: ' + window.location.href);
    }
  }